var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 91,
  height: 90,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-3_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#53BDD5",
  d: "M90.667 45c0-24.853-20.147-45-45-45s-45 20.147-45 45 20.147 45 45 45 45-20.147 45-45"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5C400",
  d: "M45.667 71.557c-7.125 0-13.909-2.197-19.099-6.183-5.726-4.4-9.007-10.692-9.007-17.258 0-19.837 3.285-12.859 9.007-17.257 5.19-3.987 11.97-6.184 19.099-6.184s13.908 2.197 19.099 6.184c5.726 4.398 9.007-1.575 9.007 17.257 0 6.566-3.285 12.859-9.007 17.258-5.19 3.986-11.97 6.183-19.1 6.183m0-30.982c-7.193 0-12.206 3.975-12.206 7.541s5.013 7.541 12.206 7.541 12.206-3.975 12.206-7.54c0-3.567-5.014-7.542-12.206-7.542"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#794B37",
  d: "M45.674 63.562c-1.414-.191-2.73-.84-4.189-1.466-2.283-.979-3.903.754-6.112.671-.746-.026-1.459-.33-2.078-.742-.866-.578-1.578-1.362-2.385-2.018-.88-.716-1.68-1.605-2.707-2.122-1.324-.668-2.696-.218-3.596-1.673-.458-.739-.653-1.609-.938-2.434-.405-1.18-1.027-2.283-1.987-3.1-.923-.785-1.98-1.4-2.48-2.566a20.2 20.2 0 0 1-1.645-7.939c0-10.36 7.312-17.79 17.04-20.325q1.108-.287 2.238-.502c9.087-1.725 20.618-1.388 28.253 4.481 5.726 4.399 8.681 9.78 8.681 16.346 0 2.085-.33 4.14-.967 6.12a21 21 0 0 1-1.178 2.9c-.634 1.278-.596 2.928-1.567 4.034-.983 1.121-2.618 1.136-3.878 1.77-1.549.78-2.644 2.34-3.675 3.683-.9 1.17-1.74 2.685-3.352 2.925-1.065.157-2.074-.488-3.135-.675-1.564-.278-3.672.592-5.078 1.23-.829.378-1.627.836-2.494 1.125a5.96 5.96 0 0 1-2.782.273zm-.566-31.357-.266.022c-2.265.244-4.347 1.001-6.488 1.733-.814.277-1.642.562-2.355 1.046-.997.679-1.71 1.721-2.126 2.854-.36.99-.506 2.077-.3 3.108.337 1.703 1.571 3.105 2.989 4.11 2.152 1.527 4.77 2.3 7.395 2.543 3.693.345 7.56-.356 10.63-2.438.972-.656 1.865-1.458 2.483-2.456.615-.997.938-2.209.732-3.36-.29-1.62-1.542-2.891-2.832-3.915-.82-.652-1.736-1.286-2.778-1.515-1.155-.247-2.385-.064-3.51-.454-1.335-.465-2.018-1.387-3.574-1.282z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "M45.742 48.765H43.78v4.42h1.962zM48.586 53.86l-.517 1.893 4.265 1.164.517-1.892z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m42.627 57.003-1.197 1.554 3.502 2.698L46.13 59.7zM53.87 46.78l-1.65 1.06 2.392 3.72 1.65-1.061zM58.792 54.712h-1.96v4.421h1.96z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m48.994 24.038-1.923-.387-.87 4.335 1.922.386zM59.388 46.962l-1.295 1.473 3.32 2.92 1.296-1.474zM26.783 34.242l-.787 1.797 4.05 1.773.787-1.797zM33.321 49.957l-1.295 1.473 3.321 2.918 1.295-1.473z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m33.378 56.114.413 1.917 4.322-.931-.413-1.917z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m59.386 31.645-1.295 1.473 3.32 2.919 1.295-1.473zM42.162 19.813l-1.295 1.473 2.595 2.28 1.294-1.473zM35.408 30.547l-1.295 1.473 2.595 2.28 1.294-1.473z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "M33.99 40.597h-1.962v3.453h1.962z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "M22.713 35.695h-1.961v3.454h1.961zM52.782 19.095l-1.295 1.473 2.595 2.28 1.294-1.473zM67.126 47.587 65.21 48l.931 4.322 1.918-.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m67.112 41.469-1.65-1.06-2.39 3.718 1.65 1.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m37.874 45.333-1.65-1.06-1.87 2.908 1.65 1.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "M38.49 24.82h-1.962v3.458h1.962zM30.462 26.364l-1.797-.787-1.386 3.167 1.796.787zM26.284 31.415l-.817-1.783-3.143 1.44.817 1.784zM29.647 49.561l-1.65-1.06-1.87 2.909 1.65 1.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m25.31 46.444-1.307-1.463-2.578 2.305 1.308 1.462z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m56.162 30.305-1.167-1.576-2.787 2.064 1.167 1.576zM61.156 24.035 59.99 22.46l-3.553 2.631 1.167 1.576zM61.005 42.986v-1.962h-4.421v1.962zM67.702 31.248v-1.96h-4.421v1.96zM30.1 42.322V40.36h-4.42v1.962z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m70.971 39.996.386-1.923-4.334-.87-.386 1.922z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-3_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.667 0h90v90h-90z"
})))));
export { SvgAvatar3 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-3.cc4186b31189022eeeb3.svg";